<template lang="pug">
  #ChallengeForfeitActionMenu
    ChallengeForfeitTeamActionMenu(v-if="challenge.between === 'groups'" :challenge="challenge")
    WtActionMenu(v-else)
      template(slot="trigger")
        slot(name="trigger")
      WtActionMenuItem.leave-challenge.has-text-danger(
        icon="flag-variant-outline"
        text="Forfeit"
        @click.native="leaveChallenge()"
      )
</template>

<script>
import { mapActions } from "vuex";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";
import ChallengeForfeitTeamActionMenu from "@@/Challenge/ChallengeForfeitTeamActionMenu";

export default {
  name: "MobileChallengeForfeitActionMenu",

  components: {
    WtActionMenu,
    WtActionMenuItem,
    ChallengeForfeitTeamActionMenu
  },

  props: {
    challenge: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      errorForfeitingChallenge: false
    };
  },

  methods: {
    ...mapActions("challenges", ["mobileRemoveMemberFromChallenge"]),
    ...mapActions(["snackBar"]),
    ...mapActions("pages", ["setPageLoaded"]),
    ...mapActions("members", ["mobileFetchChallenges"]),

    leaveChallenge() {
      this.$buefy.dialog.confirm({
        title: "Leave This Challenge",
        confirmText: "Leave This Challenge",
        type: "is-danger",
        hasIcon: true,
        message: "Are you sure you want to leave this Challenge?",
        closeOnConfirm: false,
        onConfirm: async (_, dialog) => {
          dialog.confirmText = "Processing ...";
          dialog.$refs.confirmButton.disabled = true;
          if (this.challenge.id) {
            try {
              await this.mobileRemoveMemberFromChallenge({
                challengeId: this.challenge.id,
                mobileToken: this.$route.params.mobileToken
              });
              await this.mobileFetchChallenges(this.$route.params.mobileToken);
              this.$router.go();
              this.snackBar({
                duration: 5000,
                type: "is-success",
                message: "You are no longer a member of " + this.challenge.name
              });
            } catch (error) {
              this.errorForfeitingChallenge = true;
            }
          }
          dialog.close();
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
#ChallengeForfeitActionMenu
  // override b-table, etc.
  /deep/ .level:not(.top)
    padding: 0 !important
</style>
